import { M8PromocodeSortableField } from 'services/production/types';
import { PromocodesTableSortableField } from 'types/state/promocode';
import { UnreachableError } from 'utils/errors';

export const normalizePromocodesTableSortableField = (
  promocodesTableSortableField: PromocodesTableSortableField
) => ({
  toM8PromocodeSortableField(): M8PromocodeSortableField {
    switch (promocodesTableSortableField) {
      case 'id':
        return 'id';
      case 'value':
        return 'code';
      case 'org':
        return 'id'; // TODO: заменить на соотв. полe когда на бэке появится поддержка
      case 'person':
        return 'id'; // TODO: заменить на соотв. полe когда на бэке появится поддержка
      case 'createdAt':
        return 'createdOn';
      case 'status':
        return 'promocodeStatus';
      case 'activatedAt':
        return 'activationDate';
      case 'expiresAt':
        return 'validUntil';
      default:
        throw new UnreachableError(promocodesTableSortableField);
    }
  },
});
